import PermissionContext from '../../common/components/permissions-context';
import { useContext } from '../../common/hoc/user-context';

// eslint-disable-next-line
export default useContext(PermissionContext);
